// extracted by mini-css-extract-plugin
export default {"defaults":"Paragraph_defaults__mpWry","small":"Paragraph_small__+Br5-","big":"Paragraph_big__PTbmL","center":"Paragraph_center__-FUEr"};